import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import Today from '@/page/Today'
import MyClas from '@/page/MyClass'
import MyClassList from '@/page/MyClassList'
import MyClassTil from '@/page/MyClassTil'
import MyNote from '@/page/MyNote'
import MyTest from '@/page/MyTest'
import MyDoc from '@/page/MyDoc'
import ExamList from '@/page/ExamList'
import Exam from '@/page/Exam'
import AnWord from '@/page/AnWord'
import Test from '@/page/Test'
import TodayRepeat from '@/page/TodayRepeat'
import ExamEndShow from '@/page/ExamEndShow'
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            component: Today,
            children: [{
                    path: '',
                    name: 'main',
                    component: TodayRepeat
                },
                {
                    path: 'exam',
                    name: 'today-exam',
                    component: Exam
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Home
        },
        {
            path: '/myclass',
            component: MyClas,
            children: [{
                    path: '',
                    name: 'myclass',
                    component: MyClassTil
                },
                {
                    path: ':id',
                    name: 'myclasslist',
                    component: MyClassList
                }
            ]
        },
        {
            path: '/mynote',
            name: 'mynote',
            component: MyNote
        },
        {
            path: '/mytest',
            component: MyTest,
            children: [{
                    path: '',
                    name: 'mytest',
                    component: ExamList
                },
                {
                    path: ':id',
                    name: 'exam',
                    component: Exam
                }
            ]
        },
        {
            path: '/mydoc',
            name: 'mydoc',
            component: MyDoc
        },
        {
            path: '/word',
            name: 'word',
            component: AnWord
        },
        {
            path: '/exercise',
            component: Today,
            children: [{
                    path: '',
                    name: 'exercise',
                    component: TodayRepeat
                },
                {
                    path: 'test',
                    name: 'test',
                    component: Exam
                }
            ]
        },
        {
            path: '/examend',
            name: 'examend',
            component: ExamEndShow
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js